import Route from '@ember/routing/route';
import { getOwner } from '@ember/owner';

export default class IndexRoute extends Route {
  beforeModel() {
    // Get router service
    const owner = getOwner(this);
    if (!owner) return;

    const router = owner.lookup('service:router');
    if (!router) return;

    // Redirect to default locale (English) or user's preferred locale from localStorage/cookie
    let locale = 'en';

    if (typeof window !== 'undefined') {
      // Try localStorage first
      if (window.localStorage) {
        try {
          const stored = window.localStorage.getItem('locale');
          if (stored === 'en' || stored === 'es') {
            locale = stored;
          }
        } catch (e) {
          // localStorage might be disabled, continue to cookie fallback
        }
      }

      // Fall back to cookie if localStorage didn't have it
      if (locale === 'en' && typeof document !== 'undefined') {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
          const [name, value] = cookie.trim().split('=');
          if (name === 'locale' && (value === 'en' || value === 'es')) {
            locale = value;
            break;
          }
        }
      }
    }

    // Redirect to explicit locale route
    router.replaceWith(locale);
  }
}
